module.exports = __webpack_public_path__ + "static/img/6.766186d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/6.jpg
// module id = MYfI
// module chunks = 0